// 本地硬编码 feature 开关（不走服务端下发）
//
// AI_DIRECT_CHAT_ENABLED：「不进群直接和 AI 对话发消息（AI 自动选群）」入口总开关。
// false 时：
//   - 底部导航中间「+」按钮（BottomNavBar）、侧栏「发布」按钮（SidebarNav）、
//     首页草稿续写 banner（Channels）全部隐藏；
//   - Onboarding「Get Started」结束不再自动打开 AI 对话弹窗；
//   - store 的 setShowAiChatPopup(true) 兜底忽略，覆盖所有已知的和未来新增的开启点。
// 所有 AI 对话相关代码逻辑均保留，改回 true 即恢复原行为。
// 注意：进群后的群内 AI 对话（ChannelDetail 内嵌弹窗）不受此开关影响。
export const AI_DIRECT_CHAT_ENABLED = false



// WEBPACK FOOTER //
// ./src/assets/feature_flags.js